import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { tap, map } from 'rxjs/operators';
import { ConfigService } from '../shared/utils/config.service';
import { BaseService } from '../shared/services/base.service';
import { AuthenticationService } from '../core';
import { ResetPasswordModel } from './reset-password-model';


const CREATE_ACTION = 'create';
const UPDATE_ACTION = 'update';
const REMOVE_ACTION = 'destroy';

@Injectable()
export class ChangePasswordService extends BaseService {
  private headers: HttpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
    Accept: 'application/json'
  });
  baseUrl: string = '';

  constructor(private http: HttpClient, private configService: ConfigService, private authService: AuthenticationService) {
    super();
    this.baseUrl = configService.getApiURI();
  }

  changeInitialPassword(model: ResetPasswordModel): Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded');

    return this.http
      .post<any>(this.baseUrl + '/authentication/changeInitialPassword',
        {
          "ProposedPassword": model.proposedPassword,
        });
  }
  changePassword(model: ResetPasswordModel): Observable<any> {
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/x-www-form-urlencoded');

    let accesstoken = this.authService.accessToken;
    return this.http
      .post<any>(this.baseUrl + '/authentication/changePassword',
        {
          "PreviousPassword": model.previousPassword,
          "ProposedPassword": model.proposedPassword,
          "AccessToken": accesstoken
        });
  }
}
